var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.9543 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20Z",
    fill: "#7956D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6583 14.4017L17.8983 22.1616L14.3417 18.605C13.8061 18.0694 12.9375 18.0693 12.4018 18.6049C11.8661 19.1406 11.8661 20.0091 12.4018 20.5449L16.9283 25.0715C17.1855 25.3287 17.5344 25.4733 17.8982 25.4733C18.262 25.4733 18.6109 25.3287 18.8682 25.0716L27.5982 16.3418C28.1339 15.8061 28.1339 14.9376 27.5982 14.4018C27.0625 13.8661 26.194 13.866 25.6583 14.4017Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptBtn);
export default __webpack_public_path__ + "static/media/acceptBtn.b221eb45cb1eff5eaa39abca752386e3.svg";
export { ForwardRef as ReactComponent };